import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { DadosAdicionaisModeloService } from '../services/dados-adicionais-modelo.service';


@Injectable({
  providedIn: 'root'
})
export class DadosAdicionaisModeloResolver implements Resolve<boolean> {

  constructor(private service: DadosAdicionaisModeloService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}